import { useEffect } from 'react';
import queryString from 'query-string';
import moment from "moment/moment";
import { PARAMETERS_STORAGE_KEY, SESSION_STORAGE_KEY, stripTrailingSlash } from './config';


const strippedPath = stripTrailingSlash(window.location.pathname);

export const saveSessionToStorage = (authData) =>{
    const session = createSession(authData);
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
    window.history.replaceState({}, '', strippedPath);
};

export const createSession = (authTokenData) => {
    const currentISODate = getCurrentISODate();
    const expiresInSeconds = authTokenData.expires_in - 120; // Offset two minutes
    return {
        ...authTokenData,
        expiresAt: currentISODate.add(expiresInSeconds, 'seconds').toISOString(),
    };
};

export const getCurrentISODate = () => {
    return moment(moment().toISOString());
};

export const hasSessionExpired = () => {
    const session = getSessionFromStorage();
    if (session) {
        const currentDate = getCurrentISODate();
        return currentDate.isSameOrAfter(moment(session?.expiresAt));
    }
    // window.location.href = `/login/`;
    return false;
};


export const getSessionFromStorage = () => {
    const storageSession = localStorage.getItem(SESSION_STORAGE_KEY);
    if (storageSession) {
        try {
            return JSON.parse(storageSession);
        } catch (e) {
            console.error('Could not parse session from storage.');
        }
    }
    else{
        const mParam = queryString.parse(window.location.search);
        const { mtoken, ...others } = mParam;
        if(mtoken){
            return undefined;
        }else{
            window.location.href = `/login/`;
        }
    }
};

export const useParameters = () => {
    const requestParameters = queryString.parse(window.location.search);
    const cachedParameters  = getParametersFromStorage();
    useEffect(() => {
        const { mtoken, ...others } = requestParameters;
        if (mtoken) saveParametersToStorage(others);
    }, [requestParameters]);

    return {
        requestParameters,
        cachedParameters
    };
};


export const saveParametersToStorage = (parameters) => {
    localStorage.setItem(PARAMETERS_STORAGE_KEY, JSON.stringify(parameters));
};

export const getParametersFromStorage = () => {
    const storageParameters = localStorage.getItem(PARAMETERS_STORAGE_KEY);
    if (!storageParameters) return undefined;
    return JSON.parse(storageParameters);
};


export const getTokenFromStorage = () => {
    const storageSession = localStorage.getItem(SESSION_STORAGE_KEY);
    if (storageSession) {
        try {
            const sessiondata = JSON.parse(storageSession);
            return sessiondata.access_token;
        } catch (e) {
            console.error('Could not parse session from storage.');
        }
    }
    return undefined;
}

export const authHeaders = (sessionData) => {
    if(sessionData){
        return {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+sessionData.access_token,
        }
    }
    else{
        return {
            'Content-Type': 'application/json',
        }
    }
}


// For Date Converter
const padTwoDigits = (num) =>{
    return num.toString().padStart(2, "0");
  }
  
export const dateInYyyyMmDdHhMmSs = (date, dateDiveder = "-")  => {
    const dateV = new Date(date);
    return (
        [
        dateV.getFullYear(),
        padTwoDigits(dateV.getMonth() + 1),
        padTwoDigits(dateV.getDate()),
        ].join(dateDiveder) +
        " " +
        [
        padTwoDigits(dateV.getHours()),
        padTwoDigits(dateV.getMinutes()),
        padTwoDigits(dateV.getSeconds()),
        ].join(":")
    );
}